import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CardProp {
    image: string,
    text: string,
    serviceId?: string,
}

const Card = ({image, text, serviceId}: CardProp) => {
    const { t } = useTranslation();
    const style = getStyle()
    
    const cardContent = (
        <div style={{
            ...style.container,
            transition: 'all 0.3s ease',
        }} className="group relative isolate">
            <div style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: serviceId === "sanitise" ? "22% center" : "center bottom",
                transition: 'transform 0.5s ease',
            }} className="group-hover:scale-110" />
            
            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="text-center">
                    <div className="bg-trhine-yellow-300 text-black px-4 py-2 rounded-md mb-2 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="mr-2" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg>
                        <span className="font-bold">{t('common.viewPrice')}</span>
                    </div>
                </div>
            </div>
            
            <h2 style={style.text} className="relative z-10">{text}</h2>
        </div>
    )

    if (serviceId) {
        return (
            <Link to={`/services/${serviceId}`} style={{ display: 'block', flex: '0 0 auto' }} className="isolate">
                {cardContent}
            </Link>
        );
    }

    return cardContent;
}

const getStyle = () : { [key: string]: React.CSSProperties } => ({
    container: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        justifyContent: "flex-end",
        height: "100%",
        borderTopRightRadius: 40,
        borderBottomLeftRadius: 40,
        position: "relative",
        overflow: "hidden",
        minWidth: 300,
        minHeight: 600,
        cursor: 'pointer',
    },
    text: {
        color: "white",
        paddingBottom: 22,
        paddingLeft: 22,
        paddingRight: 22,
        fontSize: "2rem",
        fontWeight: "bold"
    }
})

export default Card